import React from "react";
import { Box, Card, Flex, Small } from "orcs-design-system";
import PropTypes from "prop-types";

const ChangelogSummary = ({ summary }) => {
  if (!summary) {
    return null;
  }

  const totalTeamChanges =
    summary.teams.added + summary.teams.removed + summary.teams.moved;
  // Use total if available (includes tag/allocation-only entries), otherwise calculate from diffs
  const totalMemberChanges =
    summary.members.total !== undefined
      ? summary.members.total
      : summary.members.new + summary.members.removed + summary.members.moved;
  const totalChanges = totalTeamChanges + totalMemberChanges;

  return (
    <Box>
      <Flex flexWrap="nowrap" gap="m">
        <Card
          alternate
          icon={["fas", "chart-line"]}
          title="Total Changes"
          subtitle={totalChanges}
          colour="primary"
          flex="1"
          minWidth="250px"
        />

        <Card
          alternate
          icon={["fas", "building"]}
          title="Structures"
          subtitle={totalTeamChanges}
          colour="primary"
          flex="1"
          minWidth="250px"
        >
          <Small color="greyDark">
            {summary.teams.added} added, {summary.teams.removed} removed,{" "}
            {summary.teams.moved} moved
          </Small>
        </Card>

        <Card
          alternate
          icon={["fas", "users"]}
          title="Members"
          subtitle={totalMemberChanges}
          colour="success"
          flex="1"
          minWidth="250px"
        >
          <Small color="greyDark">
            {summary.members.new} new, {summary.members.removed} removed,{" "}
            {summary.members.moved} moved
          </Small>
        </Card>
      </Flex>
    </Box>
  );
};

ChangelogSummary.propTypes = {
  summary: PropTypes.object,
};

export default ChangelogSummary;
